import React from 'react';
import isDomain from '../../../../../shared/js/isDomain';

function getProcessedLinks(text) {
	const textArray = text.split(' ');
	const getDomain = domain => domain.replace('https://', '').replace('http://', '').replace('//', '');

	return textArray
		.map((item, index) =>
			isDomain(item) && <a
				key={index} href={`//${getDomain(item)}`} target="_blank"
				className="word-break-all"
			>
				{` ${item} `}
			</a>
		)
		.filter(Boolean);
}

export default getProcessedLinks;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/shared/processLinks.js